module.exports = __webpack_public_path__ + "static/media/badgeIOs@3x.6d1ba04b.png";